import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import GlobalStateDataProvider from './context-api/data-provider/GlobalStateDataProvider';
import { BranchLoginProvider } from './context-api/auth/BranchLoginProvider';
import { StoreManagementDataProvider } from './context-api/store-management/StoreManagementDataContext';
import { KitchenProductsDataProvider } from './context-api/kitchen-products/KitchenProductsDataContext';
import { MarketingLeadDataProvider } from './context-api/marketing-lead/MarketingLeadDataContext';
import { OrderManagementDataProvider } from './context-api/order-management/OrderManagementDataContext';
import '../src/styles/styles.css';




const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <BranchLoginProvider>
      <GlobalStateDataProvider>
        <StoreManagementDataProvider>
          <MarketingLeadDataProvider>
            <OrderManagementDataProvider>
              <KitchenProductsDataProvider>
                <App />
              </KitchenProductsDataProvider>
            </OrderManagementDataProvider>
          </MarketingLeadDataProvider>
        </StoreManagementDataProvider>
      </GlobalStateDataProvider>
    </BranchLoginProvider>
  </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
